import { IconButton, IconTextButton } from 'Components/Button';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Row,Col,Image,Stack, Button, Form, OverlayTrigger, Tooltip, Accordion, Card, AccordionContext, useAccordionButton, ListGroup, Collapse } from 'react-bootstrap';
import { isAccordionItemSelected } from 'react-bootstrap/esm/AccordionContext';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { ICONS } from 'Utils/icons';
import { PATHS } from 'Utils/PagePaths';
import CompareBtn from './CompareBtn';
import { config } from 'Utils/config';

function DEAccordionHeader({eventKey, deCardData, expandedAccGroups, setExpandedAccGroups, setExpandedGroups, expandedGroups, isExpanded, focusDe, deAccRefs}) {
    const { activeEventKey } = useContext(AccordionContext);
    const isCurrentEventKey = isAccordionItemSelected(activeEventKey, eventKey);

    useEffect(()=>{
        if(focusDe!=null){
            // If current search result is in current de group
            if(focusDe.deGroupId==deCardData.order){
                //If group's accordion is not expanded, expand it
                if(!isExpanded(deCardData.order,expandedAccGroups)){
                    setExpandedAccGroups(prev=>({
                        ...prev,
                        [deCardData.order]: true
                    }))
                }
                //If group is not expanded, expand it
                if(!isExpanded(deCardData.order,expandedGroups)){
                    setExpandedGroups(prev=>({
                        ...prev,
                        [deCardData.order]: true
                    }))
                }
                const timer = setTimeout(() => {
                    (deAccRefs.current.get(focusDe.deIdentifier))?.focus();
                }, 150); // Delay for Bootstrap slide transition
                return () => clearTimeout(timer);  
            }
            else{
                (deAccRefs.current.get(focusDe.deIdentifier))?.focus();
            }
        }
    },[focusDe])

    const decoratedOnClick = useAccordionButton(eventKey, () =>{
        if(!isExpanded(deCardData.order,expandedAccGroups)){
            setExpandedAccGroups(prev=>({
                ...prev,
                [deCardData.order]: true
            }))
        }
        else{
            setExpandedAccGroups(prev=>({
                ...prev,
                [deCardData.order]: false
            }))
        }
    })

    return (
        <Card.Header 
            as={Button} 
            variant={"comp-clear"} 
            onClick={decoratedOnClick} 
            className="d-flex btn-de-card-accordion-toggle data-element-card-header d-lg-none flex-row justify-content-between align-items-start "
        >
            <div className="d-flex flex-column gap-1 ">
                <Card.Title className="color-base-darkergray body semibold mb-0 text-start">{deCardData.title}</Card.Title>
                {
                    deCardData.titleDesc!=null
                    ?   <Card.Subtitle className="color-base-darkgray bodyS regular text-start m-0">{deCardData.titleDesc}</Card.Subtitle>
                    :   null
                } 
            </div>
            <div>
                <svg className={isCurrentEventKey ? "down-icon" : ""} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z" fill="#686E7A"/>
                </svg>
            </div>
        </Card.Header>
    );
}

function DataElementCard({ 
    tabActiveKey, 
    activeEventKey, 
    resultCategories, 
    subOnly, 
    setCompareDe, 
    setCompareDeName, 
    expandedGroups, 
    setExpandedGroups, 
    expandedAccGroups, 
    setExpandedAccGroups, 
    activeVersion, 
    deRefs, 
    deAccRefs, 
    deCardData, 
    setShowCompareModal, 
    setDrawerOpen, 
    setDrawerData, 
    focusDe
}) {
    
    const [showAdditional, setShowAdditional] = useState(false);    // If additional data elements are shown
    const [elements, setElements] = useState(deCardData.dataElements);  // data elements for card
    const [highIds, setHighIds] = useState([]); // DE identifiers of search results in current version

    useEffect(()=>{
        if(resultCategories!=null){
            var currentVerResults = resultCategories.filter((c)=>{
                // Get searh results for current event type
                var currentVerModuleResults = c[1].filter((m)=>{
                    if(m.deModuleId == activeEventKey && m.deVersionId==tabActiveKey){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // Only include if there are search results for current event type
                if(currentVerModuleResults.length>0){
                    return true;//currentVerModuleResults;
                }
                else{
                    return false;
                }
            })

            config.isDebugEnabled && console.log(activeVersion, currentVerResults, resultCategories);

            // If there are results in current version
            if(currentVerResults!=null && currentVerResults.length>0){
                var results = currentVerResults[0];

                if(results!=null && results.length>1){
                    if(results[1]!=null){
                        // Set list of deIdentifiers for current version search results
                        setHighIds(results[1].map(h => h.deIdentifier));
                    }
                    else{
                        setHighIds([]);
                    }
                }
            }
            else{
                setHighIds([]);
            }
        }
        else{
            setHighIds([]);
        }
    },[activeEventKey, resultCategories]);

    // When subOnly or data elements change
    useEffect(()=>{
        if(subOnly==true){
            // Filter data elements so only 'submit PSOPPC' DEs are included
            setElements(deCardData.dataElements.filter((e)=>{
                if(e.deAllowSubmit=="Yes"){
                    return true;
                }
                else{
                    return false;
                }
            }))
        }
        else{
            // Set DEs to include all elements
            setElements(deCardData.dataElements);
        }
    },[deCardData.dataElements, subOnly])


    useEffect(()=>{
        if(focusDe!=null){
            // If current search result is in current de group
            if(focusDe.deGroupId==deCardData.order){
                //If group is not expanded, expand it
                if(!isExpanded(deCardData.order,expandedGroups)){
                    setExpandedGroups(prev=>({
                        ...prev,
                        [deCardData.order]: true
                    }))
                }
                const timer = setTimeout(() => {
                    if((deRefs.current.get(focusDe.deIdentifier))){
                        (deRefs.current.get(focusDe.deIdentifier))?.focus();
                    }
                    if((deAccRefs.current.get(focusDe.deIdentifier))){
                        (deAccRefs.current.get(focusDe.deIdentifier))?.focus();
                    }
                }, 150); // Delay for Bootstrap slide transition
                return () => clearTimeout(timer);
            }
        }
    },[focusDe])

    // Checks if expandedGroups contains groupId, if it does it returns its current true/false value from expandedGroups
    const isExpanded = (groupId, expandedGroups) => {
        if(expandedGroups!=null && expandedGroups.hasOwnProperty(groupId)){
            return expandedGroups[groupId];
        }
        else{
            return false;
        }
    }

    // Returns highlighted className for DEs that are in highIds list
    const isHigh = (deId) => {
        if(highIds!=null && deId!=null && highIds.includes(deId)){
            return " highlighted";
        }
        else{
            return "";
        }
    }

    // Returns colored className for DE that is currently active
    const isHighColor = (deId,focusDe) => {
        if(focusDe!=null && deId!=null && deId==focusDe?.deIdentifier){
            return " colored";
        }
        else{
            return "";
        }
    }

    
    
    // Get path to DE Detail page
    const getDEPath = (deId) =>{
        return PATHS.public['Data Element Detail'].replace(":verId",activeVersion.id).replace(":deId",deId);
    }
    
    return (
        <Fragment key={"de-card-" + deCardData.order}>

            {/* Mobile View -------------------------------------- */}

            <Accordion className="data-element-card-accordion d-flex d-lg-none flex-column" defaultActiveKey={[]} alwaysOpen >
                <Card className="data-element-card shadow8">
                    <DEAccordionHeader 
                        eventKey={1} 
                        deCardData={deCardData} 
                        setExpandedGroups={setExpandedGroups} 
                        isExpanded={isExpanded} 
                        focusDe={focusDe} 
                        deAccRefs={deAccRefs} 
                        expandedGroups={expandedGroups}
                        expandedAccGroups={expandedAccGroups} 
                        setExpandedAccGroups={setExpandedAccGroups} 
                    ></DEAccordionHeader>
                    <Accordion.Collapse in={isExpanded(deCardData.order,expandedAccGroups)} unmountOnExit={true} mountOnEnter={true}>
                        <Card.Body className={"p-0"}>
                            <ListGroup className="de-list">
                                {
                                    elements.map((de, index)=>{
                                        // If index of DE is less than 10
                                        if(index<10){
                                            return (
                                                <ListGroup.Item className="data-element-card-row" key={"de-card-row-mobile-"+de.deIdentifier}>
                                                    <Button 
                                                        variant="de-details" 
                                                        className={"de-details-row " + isHighColor(de.deIdentifier, focusDe) + isHigh(de.deIdentifier)}
                                                        onClick={()=>{
                                                            setDrawerData(de);
                                                            setDrawerOpen(true);
                                                        }}
                                                        ref={(node) => {
                                                            const map = deAccRefs.current;
                                                            if (node) {
                                                                map.set(de.deIdentifier, node);
                                                            } else {
                                                                map.delete(de.deIdentifier);
                                                            }
                                                        }}
                                                    >
                                                        <div className="de-num">{de.deCode}{de.deAllowSubmit=="Yes" ? null : <span className="color-error-red">*</span>}</div>
                                                        <div className="de-name">{de.deName}</div>
                                                    </Button>
                                                </ListGroup.Item>
                                            )
                                        }
                                    })
                                }
                                {
                                    // If more than 10 Data elements
                                    elements.length>10
                                    ?   
                                        <>
                                            <Collapse in={isExpanded(deCardData.order,expandedGroups)} unmountOnExit={true}  mountOnEnter={true}>
                                                <div>
                                                    {
                                                        elements.map((de, index)=>{
                                                            if(index >= 10){
                                                                return (
                                                                    <ListGroup.Item className="data-element-card-row" key={"de-card-row-mobile-"+de.deIdentifier}>
                                                                        <Button variant="de-details" className={"de-details-row " + isHighColor(de.deIdentifier, focusDe) + isHigh(de.deIdentifier)}
                                                                            as={Link}
                                                                            to={getDEPath(de.deCode)}
                                                                            ref={(node) => {
                                                                                const map = deAccRefs.current;
                                                                                
                                                                                if (node) {
                                                                                    map.set(de.deIdentifier, node);
                                                                                } else {
                                                                                    map.delete(de.deIdentifier);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <div className="de-num">{de.deCode}{de.deAllowSubmit=="Yes" ? null : <span className="color-error-red">*</span>}</div>
                                                                            <div className="de-name">{de.deName}</div>
                                                                        </Button>
                                                                        {
                                                                            // Only H1.2 and H2.0 show compare btn
                                                                            activeVersion.id==444 || activeVersion.id == 443
                                                                            ?
                                                                                <CompareBtn
                                                                                    de={de}
                                                                                    setDrawerData={setDrawerData}
                                                                                    setShowCompareModal={setShowCompareModal}
                                                                                    setCompareDe={setCompareDe}
                                                                                    setCompareDeName={setCompareDeName}
                                                                                ></CompareBtn>
                                                                            :   null
                                                                        }
                                                                    </ListGroup.Item>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </Collapse>

                                            {/* Show more/less button */}
                                            <ListGroup.Item className="data-element-card-row btn-row">
                                                <IconTextButton 
                                                    variant="comp-plain"
                                                    className="reverse d-flex justify-content-center show-more-btn"
                                                    onClick={()=>{
                                                        setExpandedGroups(prev=>({
                                                            ...prev,
                                                            [deCardData.order]: (!isExpanded(deCardData.order,expandedGroups))
                                                        }))
                                                    }} 
                                                    content={isExpanded(deCardData.order,expandedGroups)==false ? 'Show More ('+ (elements.length-10) + ')' : 'Show Less ('+ (elements.length-10) + ')'}
                                                    icon={()=>{
                                                            if(isExpanded(deCardData.order,expandedGroups)==false){
                                                                return (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <path d="M15.8332 10.8334H10.8332V15.8334H9.1665V10.8334H4.1665V9.16675H9.1665V4.16675H10.8332V9.16675H15.8332V10.8334Z" fill="#193F64"/>
                                                                    </svg>
                                                                );
                                                            }
                                                            else{
                                                                return (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <path d="M15.8333 10.8333H4.16663V9.16667H15.8333V10.8333Z" fill="#193F64"/>
                                                                    </svg>
                                                                );
                                                            } 
                                                        }
                                                    }
                                                >
                                                </IconTextButton>
                                            </ListGroup.Item>
                                        </>
                                    :   null
                                }
                            </ListGroup>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            {/* DESKTOP VIEW -------------------------------------- */}

            <Card className="data-element-card d-none d-lg-flex shadow4">
                <Card.Header className={"d-flex flex-column gap-2 data-element-card-header"}>
                    <Card.Title className="color-base-darkergray body bold mb-0">{deCardData.title}</Card.Title>
                    {
                        deCardData.titleDesc!=null
                        ?   <Card.Subtitle className="color-base-darkgray bodyS regular text-start m-0">{deCardData.titleDesc}</Card.Subtitle>
                        :   null
                    }
                </Card.Header>
                <Card.Body className={""}>
                    <ListGroup className="de-list">
                        {
                            elements.map((de, index)=>{
                                // If index of DE is less than 10
                                if(index<10){
                                    return (
                                        <ListGroup.Item className="data-element-card-row" key={"de-card-row-"+de.deIdentifier}>
                                            <Button variant="de-details" className={"de-details-row " + isHighColor(de.deIdentifier, focusDe) + isHigh(de.deIdentifier)}
                                                as={Link}   
                                                to={getDEPath(de.deCode)} 
                                                ref={(node) => {
                                                    const map = deRefs.current;
                                                    if (node) {
                                                        map.set(de.deIdentifier, node);
                                                    } else {
                                                        map.delete(de.deIdentifier);
                                                    }
                                                }}
                                            >
                                                <div className="de-num">{de.deCode}{de.deAllowSubmit=="Yes" ? null : <span className="color-error-red">*</span>}</div>
                                                <div className="de-name">{de.deName}</div>
                                            </Button>
                                            {
                                                // Only H1.2 and H2.0 show compare btn
                                                activeVersion.id==444 || activeVersion.id == 443
                                                ?
                                                    <CompareBtn
                                                        de={de}
                                                        setDrawerData={setDrawerData}
                                                        setShowCompareModal={setShowCompareModal}
                                                        setCompareDe={setCompareDe}
                                                        setCompareDeName={setCompareDeName}
                                                    ></CompareBtn>
                                                    
                                                :   null
                                            }
                                        </ListGroup.Item>
                                    )
                                }
                            })
                        }
                        {
                            // If more than 10 Data elements
                            elements.length>10
                            ?   
                                <>
                                    <Collapse in={isExpanded(deCardData.order,expandedGroups)} unmountOnExit={true}  mountOnEnter={true}>
                                        <div>
                                            {
                                                elements.map((de, index)=>{
                                                    if(index >= 10){
                                                        return (
                                                            <ListGroup.Item className="data-element-card-row" key={"de-card-row-"+de.deIdentifier}>
                                                                <Button variant="de-details" className={"de-details-row " + isHighColor(de.deIdentifier, focusDe) + isHigh(de.deIdentifier)}
                                                                    as={Link}
                                                                    to={getDEPath(de.deCode)}
                                                                    ref={(node) => {
                                                                        const map = deRefs.current;
                                                                        if (node) {
                                                                            map.set(de.deIdentifier, node);
                                                                        } else {
                                                                            map.delete(de.deIdentifier);
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="de-num">{de.deCode}{de.deAllowSubmit=="Yes" ? null : <span className="color-error-red">*</span>}</div>
                                                                    <div className="de-name">{de.deName}</div>
                                                                </Button>
                                                                {
                                                                    // Only H1.2 and H2.0 show compare btn
                                                                    activeVersion.id==444 || activeVersion.id == 443
                                                                    ?
                                                                        <CompareBtn
                                                                            de={de}
                                                                            setDrawerData={setDrawerData}
                                                                            setShowCompareModal={setShowCompareModal}
                                                                            setCompareDe={setCompareDe}
                                                                            setCompareDeName={setCompareDeName}
                                                                        ></CompareBtn>
                                                                        
                                                                    :   null
                                                                }
                                                            </ListGroup.Item>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </Collapse>
                                    
                                    {/* Show more/less button */}
                                    <ListGroup.Item className="data-element-card-row btn-row">
                                        <IconTextButton 
                                            variant="comp-plain"
                                            className="reverse d-flex justify-content-center show-more-btn"
                                            onClick={()=>{
                                                setShowAdditional(!showAdditional);
                                                setExpandedGroups(prev=>({
                                                    ...prev,
                                                    [deCardData.order]: (!isExpanded(deCardData.order,expandedGroups))
                                                }))
                                            }} 
                                            content={
                                                isExpanded(deCardData.order,expandedGroups)==false 
                                                ?   'Show More ('+ (elements.length-10) + ')' 
                                                :   'Show Less ('+ (elements.length-10) + ')'
                                            }
                                            icon={()=>{
                                                    if(isExpanded(deCardData.order,expandedGroups)==false){
                                                        return (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M15.8332 10.8334H10.8332V15.8334H9.1665V10.8334H4.1665V9.16675H9.1665V4.16675H10.8332V9.16675H15.8332V10.8334Z" fill="#193F64"/>
                                                            </svg>
                                                        );
                                                    }
                                                    else{
                                                        return (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M15.8333 10.8333H4.16663V9.16667H15.8333V10.8333Z" fill="#193F64"/>
                                                            </svg>
                                                        );
                                                    } 
                                                }
                                            }
                                        >
                                        </IconTextButton>
                                    </ListGroup.Item>
                                </>
                            :   null
                        }
                    </ListGroup>
                </Card.Body>
            </Card>
        </Fragment>
    );
}

export default DataElementCard;